<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Annuler la résiliation de ma ligne</div>
    <div class="col-12 w-100">
        <span class="bold-text">Etes-vous sûr de vouloir annuler la résiliation de votre ligne {{ line.phoneNumber}} ?</span>
        <br><br>
        <div class="cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Non<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Oui<span></span></button>
        </div>
    </div>
</div>
